import React, { Component } from 'react';
import { Row, Button, message, Spin, Input, Select } from 'antd';
import moment from 'moment';
import { imgToPdf } from "imgtopdf";
import jsPDF from 'jspdf';
import Auth from "./Auth";
import "./index.scss";

const Option = Select.Option;
const { TextArea } = Input;

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().format('YYYY'),
            data: {
                general: "",
                sales: "",
                FB: "",
                labor: "",
                cost: "",
                other: "",
                test: ""
            },
            loading: true,
            loadingSave: false,
            print: false,
            dateData: [],
            name: "",
            user: {}
        }
    }


    componentDidMount() {
        let date = Number(this.state.date || "0");
        let dateData = [];
        let len = date - 2018 + 3;
        for (let i = 0; i < len; i++) {
            dateData.push((2018 + i).toString())
        }
        this.setState({ dateData });
        this.getDateData(this.state.date);
        try {
            const user = JSON.parse(sessionStorage.getItem('user'));
            this.setState({
                user
            });
        } catch (error) {
            console.error(error);
            this.setState({
                user: {}
            });
        }
    }

    // 获取深度嵌套json
    getJson = (arr = [], obj = {}) => {
        return arr.reduce((a, b) => a && a[b] ? a[b] : '', obj);
    }
    getDateData = (date) => {
        let data = this.state.data;
        fetch(`/getComments`, { credentials: 'include' }).then(x => x.json()).then(x => {

            this.setState({ loading: false, data: x.data.comments || {}, name: x.data.name || "" });
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = (name) => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }

        let data = {
            [name]: this.state.data[name],
        };
        if (this.state.data.id) {
            data['id'] = this.state.data.id;
        }

        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }

        fetch('/addComments', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data.id) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            message.error('保存失败' + JSON.stringify(err));
            console.error(err);
        })
    }

    downloadSG = () => {
        this.setState({ print: true, loading: true }, () => {
            imgToPdf('table4_1_1', 1.5).then(x => {
                let canvas = x.canvas;
                var pageData = canvas.toDataURL('image/png', 0.7);

                //方向默认横向，尺寸ponits, 按照图片大小进行输出
                var pdf = new jsPDF('l', 'pt', [canvas.width * 1.5, canvas.height]);
                //需要dataUrl格式
                pdf.addImage(pageData, 'PNG', 0, 0, canvas.width, canvas.height);
                pdf.save(`Corporate Office Review(${this.state.name || ""}).pdf`);
                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                message.error('导出失败请重试！');
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const data = this.state.data;
        return (
            <Spin spinning={this.state.loading}>
                <div className="table" id="table4_1_1">
                    <Row style={{ margin: "24px 0 0 24px", fontSize: 24, color: "#333" }}>Corporate Office Review 集团信息汇总</Row>
                    <Row style={{ marginTop: 10 }} className="title" >
                        {/* <Row >
                            <Select
                                placeholder="请选择年份"
                                style={{ width: 120 }}
                                value={this.state.date}
                                onChange={(str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            >
                                {this.state.dateData.map((x, i) => {
                                    return (
                                        <Option value={x} key={x}>{x}年</Option>
                                    )
                                })}
                            </Select>
                        </Row> */}

                        <Row style={{ marginTop: 10 }} >
                            <Row style={{ margin: "10px 0" }} className="new-fontSize">总体策略 General Strategy</Row>
                            <TextArea
                                rows={4}
                                placeholder="请输入备注！"
                                value={data.general || ""}
                                onChange={(e) => {
                                    let data = this.state.data;
                                    data.general = e.target.value || "";
                                    this.setState({
                                        data
                                    });
                                }}
                            />
                            <Auth name="OPS">
                                <Button
                                    type="primary"
                                    style={{ float: "right", marginTop: 10, display: this.state.print ? 'none' : '' }}
                                    onClick={() => {
                                        this.onSave('general');
                                    }}
                                // loading={this.state.loadingSave}
                                >保存</Button>
                            </Auth>
                        </Row>


                        <Row style={{ marginTop: 10 }} >
                            <Row style={{ margin: "10px 0" }} className="new-fontSize">市场销售 Sales & Marketing</Row>
                            <TextArea
                                rows={4}
                                placeholder="请输入备注！"
                                value={data.sales || ""}
                                onChange={(e) => {
                                    let data = this.state.data;
                                    data.sales = e.target.value || "";
                                    this.setState({
                                        data
                                    });
                                }}
                            />
                            <Auth name="SM">
                                <Button
                                    type="primary"
                                    style={{ float: "right", marginTop: 10, display: this.state.print ? 'none' : '' }}
                                    onClick={() => {
                                        this.onSave('sales');
                                    }}
                                // loading={this.state.loadingSave}
                                >保存</Button>
                            </Auth>
                        </Row>

                        <Row style={{ marginTop: 10 }} >
                            <Row style={{ margin: "10px 0" }} className="new-fontSize">餐饮方面 F&B</Row>
                            <TextArea
                                rows={4}
                                placeholder="请输入备注！"
                                value={data.FB || ""}
                                onChange={(e) => {
                                    let data = this.state.data;
                                    data.FB = e.target.value || "";
                                    this.setState({
                                        data
                                    });
                                }}
                            />
                            <Auth name="FB">
                                <Button
                                    type="primary"
                                    style={{ float: "right", marginTop: 10, display: this.state.print ? 'none' : '' }}
                                    onClick={() => {
                                        this.onSave('FB');
                                    }}
                                // loading={this.state.loadingSave}
                                >保存</Button>
                            </Auth>
                        </Row>

                        <Row style={{ marginTop: 10 }} >
                            <Row style={{ margin: "10px 0" }} className="new-fontSize">人力成本 Labor</Row>
                            <TextArea
                                rows={4}
                                placeholder="请输入备注！"
                                value={data.labor || ""}
                                onChange={(e) => {
                                    let data = this.state.data;
                                    data.labor = e.target.value || "";
                                    this.setState({
                                        data
                                    });
                                }}
                            />
                            <Auth name="HR">
                                <Button
                                    type="primary"
                                    style={{ float: "right", marginTop: 10, display: this.state.print ? 'none' : '' }}
                                    onClick={() => {
                                        this.onSave('labor');
                                    }}
                                // loading={this.state.loadingSave}
                                >保存</Button>
                            </Auth>
                        </Row>

                        <Row style={{ marginTop: 10 }} >
                            <Row style={{ margin: "10px 0" }} className="new-fontSize">能源成本 Utility Cost</Row>
                            <TextArea
                                rows={4}
                                placeholder="请输入备注！"
                                value={data.cost || ""}
                                onChange={(e) => {
                                    let data = this.state.data;
                                    data.cost = e.target.value || "";
                                    this.setState({
                                        data
                                    });
                                }}
                            />
                            <Auth name="ENG">
                                <Button
                                    type="primary"
                                    style={{ float: "right", marginTop: 10, display: this.state.print ? 'none' : '' }}
                                    onClick={() => {
                                        this.onSave('cost');
                                    }}
                                // loading={this.state.loadingSave}
                                >保存</Button>
                            </Auth>
                        </Row>


                        <Row style={{ marginTop: 10 }} >
                            <Row style={{ margin: "10px 0" }} className="new-fontSize">其他费用 Other Expense</Row>
                            <TextArea
                                rows={4}
                                placeholder="请输入备注！"
                                value={data.other || ""}
                                onChange={(e) => {
                                    let data = this.state.data;
                                    data.other = e.target.value || "";
                                    this.setState({
                                        data
                                    });
                                }}
                            />
                            <Auth name="FIN">
                                <Button
                                    type="primary"
                                    style={{ float: "right", marginTop: 10, display: this.state.print ? 'none' : '' }}
                                    onClick={() => {
                                        this.onSave('other');
                                    }}
                                // loading={this.state.loadingSave}
                                >保存</Button>
                            </Auth>
                        </Row>

                        <Row style={{ marginTop: 10 }} >
                            <Row style={{ margin: "10px 0" }} className="new-fontSize">考核机制 Performance Test</Row>
                            <TextArea
                                rows={4}
                                placeholder="请输入备注！"
                                value={data.test || ""}
                                onChange={(e) => {
                                    let data = this.state.data;
                                    data.test = e.target.value || "";
                                    this.setState({
                                        data
                                    });
                                }}
                            />
                            <Auth name="FIN">
                                <Button
                                    type="primary"
                                    style={{ float: "right", marginTop: 10, display: this.state.print ? 'none' : '' }}
                                    onClick={() => {
                                        this.onSave('test');
                                    }}
                                // loading={this.state.loadingSave}
                                >保存</Button>
                            </Auth>
                        </Row>


                        <Row style={{ marginTop: 10 }} >
                            <Row style={{ margin: "10px 0" }} className="new-fontSize">业主信息 Owners' Information</Row>
                            <TextArea
                                rows={4}
                                placeholder="请输入备注！"
                                value={data.owers || ""}
                                onChange={(e) => {
                                    let data = this.state.data;
                                    data.owers = e.target.value || "";
                                    this.setState({
                                        data
                                    });
                                }}
                            />
                            <Auth name="OPS">
                                <Button
                                    type="primary"
                                    style={{ float: "right", marginTop: 10, display: this.state.print ? 'none' : '' }}
                                    onClick={() => {
                                        this.onSave('owers');
                                    }}
                                // loading={this.state.loadingSave}
                                >保存</Button>
                            </Auth>
                        </Row>
                    </Row>
                </div>
                <Row className="table-footer-btn" style={{ textAlign: "right", padding: 24 }}>
                    <Button
                        type="primary"
                        style={{ marginRight: 10 }}
                        onClick={this.downloadSG}
                        loading={this.state.print}
                    >导出PDF</Button>
                    {/* <Button
                            type="primary"
                            onClick={this.onSave}
                            // loading={this.state.loadingSave}
                        >保存</Button> */}
                </Row>


            </Spin >
        );
    }
}

export default index;





// WEBPACK FOOTER //
// ./src/bp-views/comments/index.js